// <product-modal>: quick-view dialog. A card's [data-quick-view] button fetches
// a compact product view via the ?view=quickview alternate template, injects it,
// and opens the modal. Add-to-cart inside the modal is handled by the site-wide
// product-form.js submit delegation, which then opens the cart drawer.
customElements.define(
  "product-modal",
  class extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector("[data-qv-body]");
      this.addEventListener("click", (e) => {
        if (e.target.closest("[data-qv-close]") || e.target.matches("[data-qv-scrim]")) this.close();
      });
      document.addEventListener("keydown", (e) => e.key === "Escape" && this.close());
      // Adding to cart from the modal opens the drawer — hide the modal for it
      // without clearing body overflow (the drawer manages the scroll lock).
      document.addEventListener("cart:open", () => this.setAttribute("aria-hidden", "true"));
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-quick-view]");
        if (!btn || !btn.dataset.url) return;
        e.preventDefault();
        this.load(btn.dataset.url);
      });
    }
    async load(url) {
      this.open();
      this.body.innerHTML = window.theme.skeleton("pdp");
      try {
        const res = await fetch(url + (url.includes("?") ? "&" : "?") + "view=quickview");
        if (!res.ok) throw new Error("bad response");
        const doc = new DOMParser().parseFromString(await res.text(), "text/html");
        const content = doc.querySelector(".quick-view");
        if (!content) throw new Error("no content");
        this.body.replaceChildren(content);
      } catch {
        this.body.innerHTML =
          '<div class="flex h-[320px] flex-col items-center justify-center gap-2 p-8 text-center font-body text-[14px] text-label-muted">' +
          "Couldn’t load this product." +
          '<a class="font-bold text-primary" href="' + url + '">Open the product page</a></div>';
      }
    }
    open() {
      this.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    close() {
      this.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
  }
);
